import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Pagination from "@mui/lab/Pagination";
import StickerCard from "./StickerCard";
import { useUser } from "../Contexts/UserContext";
import { Paper, Typography } from "@mui/material";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;
const Sticker = styled(Paper)(({ theme }) => ({
  position: "relative",
  padding: theme.spacing(2),
  backgroundColor: "#fff",
  border: "1px solid #333",
  borderRadius: "5px",
  marginBottom: theme.spacing(0),
  overflow: "hidden",
}));

const DateText = styled(Typography)(({ theme }) => ({
  fontSize: "0.8rem",
  color: "#555",
  marginBottom: theme.spacing(1),
}));

const MessageText = styled(Typography)(({ theme }) => ({
  fontSize: "0.9rem",
  color: "#333",
}));
const Root = styled("div")(({ theme }) => ({
  padding: theme.spacing(2),
  maxWidth: "400px",
  margin: "0px auto",
  backgroundColor: "#f0f0f0",
  borderRadius: "10px",
  border: "1px solid #ccc",
}));

const Heading = styled("div")(({ theme }) => ({
  textAlign: "center",
  marginBottom: theme.spacing(0),
  fontSize: "1.2rem",
  color: "#333",
}));

const FeedbackList = ({ data }) => {
  const [page, setPage] = useState(1);
  const [compData, setCompData] = useState([]);
  const { user } = useUser();
  const { ClientId, CompCode } = user;

  useEffect(() => {
    const fetchInitdata = async () => {
      const response = await fetch(
        `${API_URL}/facility/GetFeedBackData/1/${CompCode}/${ClientId}/UNTPFS00008511/1`
      ).then((res) => res.json());
      if (response.success) {
        setCompData(response.data);
      } else {
        alert("Cannot Fetch Feedback Data");
      }
    };
    fetchInitdata();
  }, [ClientId]);
  const itemsPerPage = 2;
  const handleChange = (event, value) => {
    setPage(value);
  };

  const paginatedData = compData.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  return (
    <Root>
      <Heading>Feedback Messages</Heading>
      <Grid container spacing={2}>
        {paginatedData.length > 0 &&
          paginatedData.map((obj, index) => (
            <Grid item xs={12} key={index}>
              {ClientId !== "11542" ? (
                <StickerCard date={obj.Date} text={obj.Remark} />
              ) : (
                // <StickerCard date="23 June" text={item} />
                <>
                  <Sticker elevation={3}>
                    <DateText variant="subtitle1">{obj.Name}</DateText>
                    <MessageText variant="body2">
                      {ClientId === "11542" &&
                      obj &&
                      Array.isArray(obj.remarkOptions) &&
                      obj.remarkOptions.length === 0
                        ? obj.feedback
                        : `Need Improvement in this Area (${
                            Array.isArray(obj.remarkOptions)
                              ? ""
                              : obj.remarkOptions
                          })`}
                    </MessageText>
                  </Sticker>
                </>
              )}
            </Grid>
          ))}
      </Grid>
      <Pagination
        count={Math.ceil(data.length / itemsPerPage)}
        page={page}
        onChange={handleChange}
        color="primary"
        style={{ marginTop: "10px", display: "flex", justifyContent: "center" }}
      />
    </Root>
  );
};

export default FeedbackList;
